import Utility from './Utility';

export default class StylesConstants {
  static getHeaderHeight = () => (Utility.isIOS() ? 44 + Utility.topInset : 56);
}
